import { isSectionHiddenByPrefs, NO_READING_PREFS, type ReadingPrefs } from './sectionTopics'

/**
 * Gesamtdauer eines Artikels: Haupttext plus alle Abschnitte (Einleitung, Science,
 * Learning, Risks, Ende). Liegt der Text nur in den Abschnitten, ist `duration`
 * leer und allein deren Summe zählt. Wer Einleitung- und/oder Ende-Abschnitte
 * ausgeblendet hat, bekommt deren Dauer hier bereits herausgerechnet.
 */
export function getArticleTotalDuration(
  article: {
    duration?: number | null
    sections?: { topic?: string | null; duration?: number | null }[] | null
  },
  prefs: ReadingPrefs = NO_READING_PREFS
): number {
  const sectionsDuration = (article.sections ?? []).reduce(
    (sum, section) =>
      isSectionHiddenByPrefs(section.topic, prefs) ? sum : sum + (section.duration ?? 0),
    0
  )
  return (article.duration ?? 0) + sectionsDuration
}

/**
 * Gesamtdauer eines Kapitels, aus seinen Artikeln aufsummiert statt aus dem
 * gespeicherten `chapters.duration` gelesen - so verschwindet ausgeblendete
 * Einleitung/Ende auch aus den Kapitel-Badges in den Listen. Fehlen `articles`
 * (Query hat sie nicht geladen), bleibt der gespeicherte Wert der Rückfall.
 */
export function getChapterTotalDuration(
  chapter: {
    duration?: number | null
    articles?:
      | {
          duration?: number | null
          sections?: { topic?: string | null; duration?: number | null }[] | null
        }[]
      | null
  },
  prefs: ReadingPrefs = NO_READING_PREFS
): number {
  if (!chapter.articles) return chapter.duration ?? 0
  return chapter.articles.reduce((sum, article) => sum + getArticleTotalDuration(article, prefs), 0)
}

/** Reine Zeitangabe "M:SS" - z.B. für die Artikel-Buttons, wo der Kontext klar ist. */
export function formatMinSec(totalSeconds: number): string {
  const mins = Math.floor(totalSeconds / 60)
  const secs = Math.floor(totalSeconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

export function formatDurationMinSec(totalSeconds: number): string {
  return `${formatMinSec(totalSeconds)} min`
}
